import { FilterOption } from '@britishcouncil/react-admin';
import { useMemo } from 'react';

import { useGetAllCountriesQuery } from 'store/dictionaries/examinerDictionariesApi';

export function useAllCountriesOptions(): FilterOption<number>[] {
  const { data } = useGetAllCountriesQuery();

  const options = useMemo(
    () =>
      data
        ?.slice()
        .sort((a, b) => a.sortOrder - b.sortOrder)
        .map((country) => ({
          text: country.name,
          value: country.id,
        })) ?? [],
    [data]
  );

  return options;
}
